import { CompanyForm } from "@/features/company/components/CompanyForm";

export const CompanyCreatePage = () => {
  return <CompanyForm />;
};
